import { render, staticRenderFns } from "./CheckoutConfirmationComponent.vue?vue&type=template&id=5a3845b6&"
import script from "./CheckoutConfirmationComponent.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfirmationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports